module.exports = __webpack_public_path__ + "static/Crater Laker-10db5db2957ff5fdd810e7f6943084db.jpg";